var berlinQuestions = [{
    "id": "301",
    "question": "Welches Wappen gehört zum Bundesland Berlin?",
	  "image": "321",
    "answers": [
		{
			content: "1",
			key: 0
		},
		{
			content: "2",
			key: 0
		},
		{
			content: "3",
			key: 0
		},
		{
			content: "4",
			key: 1
		}
	],
	"category": "Berlin",
	},{
    "id": "302",
    "question": "Welches ist ein Bezirk von Berlin?",
    "answers": [
		{
			content: "Altona",
			key: 0
		},
		{
			content: "Prignitz",
			key: 0
		},
		{
			content: "Pankow",
			key: 0
		},
		{
			content: "Demmin",
			key: 1
		}
	],
	"category": "Berlin",
	},{
    "id": "303",
    "question": "Für wie viele Jahre wird das Landesparlament in Berlin gewählt?",
    "answers": [
		{
			content: "3",
			key: 0
		},
		{
			content: "4",
			key: 0
		},
		{
			content: "5",
			key: 1
		},
		{
			content: "6",
			key: 0
		}
	],
	"category": "Berlin",
	},{
    "id": "304",
    "question": "Ab welchem Alter darf man in Berlin bei Kommunalwahlen (Wahl der Bezirksverordnetenversammlung) wählen?",
    "answers": [
		{
			content: "14",
			key: 0
		},
		{
			content: "16",
			key: 1
		},
		{
			content: "18",
			key: 0
		},
		{
			content: "20",
			key: 0
		}
	],
	"category": "Berlin",
	},{
    "id": "305",
    "question": "Welche Farben hat die Landesflagge von Berlin?",
    "answers": [
		{
			content: "blau-weiß-rot",
			key: 0
		},
		{
			content: "weiß-rot",
			key: 1
		},
		{
			content: "grün-weiß-rot",
			key: 0
		},
		{
			content: "schwarz-gold",
			key: 0
		}
	],
	"category": "Berlin",
	},{
    "id": "306",
    "question": "Wo können Sie sich in Berlin über politische Themen informieren?",
    "answers": [
		{
			content: "beim Ordnungsamt der Gemeinde",
			key: 0
		},
		{
			content: "bei den Kirchen",
			key: 1
		},
		{
			content: "bei der Verbraucherzentrale",
			key: 0
		},
		{
			content: "bei der Landeszentrale für politische Bildung",
			key: 1
		}
	],
	"category": "Berlin",
	},{
    "id": "307",
    "question": "Welches Bundesland ist ein Stadtstaat?",
    "answers": [
		{
			content: "Berlin",
			key: 1
		},
		{
			content: "Saarland",
			key: 0
		},
		{
			content: "Brandenburg",
			key: 0
		},
		{
			content: "Hessen",
			key: 0
		}
	],
	"category": "Berlin",
	},{
    "id": "308",
    "question": "Welches Bundesland ist Berlin?",
	  "image": "328",
    "answers": [
		{
			content: "1",
			key: 0
		},
		{
			content: "2",
			key: 0
		},
		{
			content: "3",
			key: 0
		},
		{
			content: "4",
			key: 1
		}
	],
	"category": "Berlin",
	},{
    "id": "309",
    "question": "Wie nennt man den Regierungschef / die Regierungschefin des Stadtstaates Berlin?",
    "answers": [
		{
			content: "Ministerpräsident / Ministerpräsidentin",
			key: 0
		},
		{
			content: "Oberbürgermeister / Oberbürgermeisterin",
			key: 0
		},
		{
			content: "Präsident / Präsidentin des Senats",
			key: 0
		},
		{
			content: "Regierender Bürgermeister / Regierende Bürgermeisterin",
			key: 1
		}
	],
	"category": "Berlin",
	},{
    "id": "310",
    "question": "Welchen Senator / welche Senatorin hat Berlin nicht?",
    "answers": [
		{
			content: "Finanzsenator / Finanzsenatorin",
			key: 0
		},
		{
			content: "Innensenator / Innensenatorin",
			key: 0
		},
		{
			content: "Senator / Senatorin für Außenbeziehungen",
			key: 1
		},
		{
			content: "Justizsenator / Justizsenatorin",
			key: 0
		}
	],
	"category": "Berlin",
	}
]

export default berlinQuestions;
